<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      
      <div class="col-md-8" style="padding-bottom: 10px">
        <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select 
            @change="getData" 
            size="small" 
            v-model="item.status"
            placeholder="Statuslara görə axtarış"
          >
            <el-option label="Bütün" :value="0"></el-option>
            <el-option label="İş yaradıldı" :value="45"></el-option>
            <el-option label="DYP sənədləri qəbul olundu" :value="50"></el-option>
            <el-option label="İş qiymətləndirməyə ötürülüb" :value="70"></el-option>
            <el-option label="Daxili qiymətləndirmə başlanılıb" :value="80"></el-option>
            <el-option label="Qiymət təsdiqə göndərildi (Qiymətləndirmə)" :value="136"></el-option>
            <el-option label="Geri qaytarılıb (Qiymətləndirmə)" :value="137"></el-option>
            <el-option label="Qiymətləndirmənin işi yekunlaşdı" :value="140"></el-option>
            <el-option label="Sənədlərin yığılması və yekunlaşdırılması" :value="141"></el-option>
            <el-option label="Aktlaşdırma başlanıb" :value="150"></el-option>
            <el-option label="Təsdiqlənməyə göndərilib" :value="151"></el-option>
            <el-option label="Təsdiqlənmədən geri qayıdıb" :value="152"></el-option>
            <el-option label="Ödənişdən geri qayıdıb" :value="153"></el-option>
          </el-select>
            &nbsp;
            <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search"
              @click="getData"></el-button>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12" style="margin-top: 25px;">
        <el-input placeholder="Axtar" size="small" v-model="search"> </el-input>
      </div>
      <div class="col-md-8 col-12">
        <el-checkbox @change="getData" v-model="item.myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
        <!-- <el-checkbox @change="getData" v-model="item.newClaim">{{$t('İş_açılıb')}}</el-checkbox>
        <el-checkbox @change="getData" v-model="item.noResponsible">{{$t('Məsul_şəxs_təyin_olunmayıb')}} </el-checkbox> -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table  v-loading="loading" :data="
          data.filter(
            (data) =>
              !search ||
              data.claimNumber
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase()) ||
              data.participants
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase())
          )
        " style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
              <div class="col-11">
                <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
              </div>
            </div>
          </template>
        </el-table-column>
          <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="100">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Status')" width="350">
            <template slot-scope="scope">
              <status-label :type="
               scope.row.statusTypeId === 45
                    ? 'indigo'
                    : '' || scope.row.statusTypeId === 50
                    ? 'forestGreen'
                    : '' || scope.row.statusTypeId === 70
                    ? 'goldenrod'
                    : '' || scope.row.statusTypeId === 75
                    ? 'limeGreen'
                    : '' || scope.row.statusTypeId === 80
                    ? 'mediumBlue'
                    : '' || scope.row.statusTypeId === 95
                    ? 'greenYellow'
                    : '' || scope.row.statusTypeId === 110
                    ? 'coral'
                    : '' || scope.row.statusTypeId === 140
                    ? 'salmon'
                    : ''|| scope.row.statusTypeId === 130
                    ? 'olive'
                    : ''|| scope.row.statusTypeId === 160
                    ? 'lightblue'
                    : ''|| scope.row.statusTypeId === 150
                    ? 'forestGreen'
                    : ''|| scope.row.statusTypeId === 160
                    ? 'greenYellow'
                    : '' || scope.row.statusTypeId === 152
                    ? 'red'
                    : '' || scope.row.statusTypeId === 153
                    ? 'red'
                    : ''
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('Məsul_şəxs_/_Müştəri_xidməti')" width="230" prop="clientServiceUserName">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Qiymətləndirici')" width="230" prop="techExpertUserName">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Hüquqi_ekspert')" prop="legalExpertUserName">
          </el-table-column>
          <el-table-column fixed="right" width="50">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button title="İşə keçid" @click="handleEdit(scope.row.id)" style="padding: 0 !important" size="large">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusLabel from "../components/StatusLabel.vue";
  import { GetClientServiceActiveClaims } from "src/services/common";
  import {
    SendToTechExpert,
    SendToLegalExpert,
    DeleteClaim,
    GetClaimAct,
  } from "../../services/claim";
  export default {
    components: {
      StatusLabel,
    },
    data() {
      return {
        loading: false,
        showModal: false,
        data: [],
        search: "",
        act: [],
        item: {
          myData: false,
          status: 0,
        },
        uid: this.$store.state.user.id,
      };
    },
    methods: {
      handleCommand(command) {
        let item = command.row;
        let id = command.id;
        if (command.action === "edit") this.handleEdit(item.id);
        else if (command.action === "delete") this.handleDelete(id);
        else if (command.action === "techexpert") this.handleTechExpert(id);
        // else if (command.action === "legalexpert") this.handleLegalExpert(id);
      },
      handleEdit(id) {
        this.$router.push({
          path: "claim/" + id,
        });
      },
      handleDelete(id) {
        this.$confirm("İş ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            DeleteClaim(id, this.uid).then((response) => {
              if (response.data.data) {
                if (!!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "İş ləğv olundu",
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      handleTechExpert(id) {
        this.$confirm("Qiymətləndirməyə göndərilsin?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        })
          .then(() => {
            this.loading = true;
            SendToTechExpert(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data.data) {
                if (!!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Qiymətləndirməyə göndərildi",
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      
      getClaimAct(id) {
        return new Promise((resolve, reject) => {
          GetClaimAct(id).then((response) => {
            if (response.data.data) {
              this.act = response.data.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      getData() {
        this.loading = true;
        this.item.commandUserId = this.uid;
        GetClientServiceActiveClaims(
          this.item
        ).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
          }
        });
      },

    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>